import { connect } from 'react-redux';
import ViziaPlatform from '../components/ViziaPlatform.jsx';

import { toggleInfoConsole, closeFullscreenDialog } from '../actions/ui';
import {getFolderByInviteId, getShouldShowDialogBackground} from '../selectors';

const mapStateToProps = (state, props) => ({
  options: getFolderByInviteId(state, props).options,
  isConsoleOpen: state.ui.console.isOpen,
  showDialogBackground: getShouldShowDialogBackground(state),
  isFullscreenDialogOpen: state.ui.fullscreenPanel.isOpen,
  fullscreenProps: state.ui.fullscreenPanel.props,
});

const mapDispatchToProps = ({
  toggleInfoConsole,
  closeFullscreenDialog
});

export default connect(mapStateToProps, mapDispatchToProps)(ViziaPlatform);
